import React from 'react';
import { useSelector } from 'react-redux';
import { update } from '../../services/item';
import { deepCloneArray } from '../../utils/array';
import { getId } from '../../utils/item';
import { ConditionSettingsEditState } from './condition.SettingsEditState';
import { FaStar } from 'react-icons/fa';
import { BtnSimple } from '../form/btn.Simple';
import {
  WidgetSettingsRoot,
  WidgetSettingsCollapsibleSection,
  HelpMarkdownSection,
  SettingsInput,
  SettingsRow,
  DangerZone,
} from '../form/settings.Widget';

export const ConditionSettings = props => {
  const { itemId, conditionId, condition, updateField } = props;

  const item = useSelector(state => state.items[itemId]);
  const deleteCondition = () => {
    const clonedConditions = deepCloneArray(item.conditions);
    const idx = clonedConditions.findIndex(
      conditionObj => getId(conditionObj) === conditionId
    );
    if (idx > -1) {
      clonedConditions.splice(idx, 1);
      update(`items/${itemId}`, 'conditions', clonedConditions);
    }
  };

  return (
    <WidgetSettingsRoot>
      <WidgetSettingsCollapsibleSection title='Général' defaultOpen={true}>
        <div className='flex flex-col gap-05'>
          <SettingsRow label='Groupe exclusif' dense>
            <SettingsInput
              placeholder={'groupe'}
              initValue={condition?.group ?? ''}
              onBlur={value => {
                const sanitized = value?.trim() === '' ? null : value?.trim();
                updateField(sanitized, 'group');
              }}
            />
          </SettingsRow>
          <div className='flex justify-end'>
            <BtnSimple
              sm
              className={`flex items-center gap-03 ${
                condition?.defaultInGroup ? 'bg-secondary' : 'bg-primary'
              }`}
              onClick={() =>
                updateField(!condition?.defaultInGroup, 'defaultInGroup')
              }
            >
              <FaStar /> Bouton par défaut
            </BtnSimple>
          </div>
        </div>
      </WidgetSettingsCollapsibleSection>

      <HelpMarkdownSection
        value={condition?.tooltip ?? null}
        onChange={value => updateField(value, 'tooltip')}
        previewTextId={conditionId + '-tooltip-preview'}
        previewItemId={itemId}
        defaultOpen={false}
      />

      <WidgetSettingsCollapsibleSection title='Bouton actif' defaultOpen={false}>
        <ConditionSettingsEditState
          condition={condition}
          state={'active'}
          itemId={itemId}
          updateField={updateField}
        />
      </WidgetSettingsCollapsibleSection>

      <WidgetSettingsCollapsibleSection
        title='Bouton inactif'
        defaultOpen={false}
      >
        <ConditionSettingsEditState
          condition={condition}
          state={'inactive'}
          itemId={itemId}
          updateField={updateField}
        />
      </WidgetSettingsCollapsibleSection>
      <DangerZone
        confirmId={'delete' + conditionId + itemId}
        closeModalId={conditionId}
        message='Voulez-vous vraiment supprimer ce bouton ?'
        onConfirm={deleteCondition}
      />
    </WidgetSettingsRoot>
  );
};
